import { TankLoadable } from './utils'
export const routerList = [
  {
    path: '/home',
    name: '介绍',
    component: TankLoadable('/home/Main'),
    exact: true
  }
]
